import { EntityType } from "@mapmycustomers/shared/enum";
import AnyColor from "@mapmycustomers/shared/types/AnyColor";
import { MapEntity } from "@mapmycustomers/shared/types/entity";

// The color to show next to a record: the legend-resolved one when the fetch asked for it, else a
// deal's stage color. Companies and people always carry a color, deals only with pinLegends.
const getMapEntityColor = (entity: MapEntity): AnyColor | undefined =>
  entity.color ?? (entity.entity === EntityType.DEAL ? entity.stage.color : undefined);

export default getMapEntityColor;
